export enum ExportSearchCallerTypeEnum {
    FILE_EXPORT_SAVED_MENTION = 'FILE_EXPORT_SAVED_MENTION',
    FILE_EXPORT_UNSAVED_MENTION = 'FILE_EXPORT_UNSAVED_MENTION',
    FILE_EXPORT_SOCIAL = 'FILE_EXPORT_SOCIAL',
}
